import React from "react";
import "./SideIntro.css";

const SideIntro = ({ title, details, content }) => {
  return (
    <div className="SideIntro-container">
      <div className="SideIntro-content">
        {content.map((item, index) => (
          <div
            key={item.id}
            className={`SideIntro-item ${
              index % 2 === 0 ? "left-content" : "right-content"
            }`}
          >
            <div className="SideIntro-text">
              <h2>{item.heading}</h2>
              <p>{item.description}</p>
            </div>
            <div className="SideIntro-image">
              <img src={item.image} alt={item.heading} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SideIntro;
